import { HttpClient } from '@angular/common/http';
import { Balance } from './accounts/balance';
import { Funds } from './accounts/funds';
import { Pools } from './accounts/pools';
import { PositionUpdates } from './accounts/position-updates';
import { Positions } from './accounts/positions';
import { Base } from '../base';

export class Accounts extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/accounts`);
  }

  of(id: string) {
    id = id.toLowerCase();
    return {
      funds: new Funds(this.httpClient, this.pathJoin(id)),
      positionUpdates: new PositionUpdates(this.httpClient, this.pathJoin(id)),
      pools: new Pools(this.httpClient, this.pathJoin(id)),
      positions: new Positions(this.httpClient, this.pathJoin(id)),
      balance: new Balance(this.httpClient, this.pathJoin(id))
    };
  }
}
